import { differenceInDays } from "date-fns";

import { DaysConverter } from "./DaysConverter";

export const JobPostedAge = (time: string | Date | null | undefined) => {
  if (!time) {
    return DaysConverter(time);
  }

  const postedAt = new Date(time);
  if (Number.isNaN(postedAt.getTime())) {
    return DaysConverter(time);
  }

  const ageInDays = differenceInDays(new Date(), postedAt);
  if (ageInDays > 62) {
    return "1+ Month";
  }

  if (ageInDays > 31) {
    return "1 Month";
  }

  return DaysConverter(time);
};
